import React from 'react';
import {Slider} from '@mui/material';
import {Body, Tooltip} from '@lightricks/react-design-system';
import styles from './CollaborationRateSelect.module.scss';
import translate from '@/utils/translate';
import InfoBox from '@/components/info-box/InfoBox';

interface CollaborationRateSelectProps {
  selectedRate: number | undefined;
  onRateChange: (rate: number) => void;
}

const RATE_STEPS = [
  {value: 0, label: '$0'},
  {value: 1000, label: undefined},
  {value: 2000, label: undefined},
  {value: 3000, label: undefined},
  {value: 4000, label: undefined},
  {value: 5000, label: '$5000+'},
];

function ValueLabel(props: {children: React.ReactElement; value: number}) {
  const {children, value} = props;

  return (
    <Tooltip
      title={<Body size="md">${value}</Body>}
      arrow
      placement="top-start"
      disableInteractive
    >
      {children}
    </Tooltip>
  );
}

export default function CollaborationRateSelect({
  selectedRate,
  onRateChange,
}: CollaborationRateSelectProps) {
  if (selectedRate === undefined) {
    onRateChange(0);
  }

  const shouldShowTooltip = selectedRate !== 0 && selectedRate !== 5000;

  return (
    <div className={styles.container}>
      <Slider
        className={styles.slider}
        value={selectedRate}
        marks={RATE_STEPS}
        step={null}
        min={0}
        max={5000}
        track="inverted"
        slots={{
          valueLabel: ValueLabel,
        }}
        slotProps={{
          valueLabel: {
            value: selectedRate,
          },
        }}
        valueLabelDisplay={shouldShowTooltip ? 'auto' : 'off'}
        onChange={(event, value) =>
          onRateChange(Array.isArray(value) ? value[0] : value)
        }
      />
      <InfoBox
        className={styles.infoBox}
        boxStyle="purple"
        infoIcon="Features-Trending"
        infoMessage={
          <div>
            <p>
              {/* eslint-disable-next-line no-template-curly-in-string */}
              {translate('Your starting rate: ${selectedRate}', {
                selectedRate,
              })}
            </p>
            <p>
              {translate(
                'Higher minimums mean fewer gigs — but better match your rate goals.'
              )}
            </p>
          </div>
        }
      />
    </div>
  );
}
